/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const ArrowRightIcon = createIcon({
  displayName: "ArrowRightIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75011 2.43923L11.0733 6.76245C11.7568 7.44587 11.7568 8.55391 11.0733 9.23732L6.75011 13.5605L5.68945 12.4999L10.0127 8.17666C10.1103 8.07903 10.1103 7.92074 10.0127 7.82311L5.68945 3.49989L6.75011 2.43923Z"
        fill="currentColor"
      />
    </g>
  )
});
